/** Block stop-page preview - same fixed stage pattern as PopupPreview. */
export function BlockPreview({
  title,
  message,
  showContact,
  device = "desktop",
}: {
  title: string;
  message: string;
  showContact: boolean;
  device?: "desktop" | "mobile";
}) {
  const mobile = device === "mobile";
  return (
    <div
      className={`sg-preview-stage${mobile ? " sg-preview-stage--mobile" : " sg-preview-stage--desktop"}`}
    >
      <div className="sg-preview-viewport sg-preview-viewport--block">
        <div className="sg-preview-bg">
          <div className="sg-preview-bg-chrome" />
          <div className="sg-preview-bg-lines">
            <span />
            <span />
            <span />
          </div>
        </div>
        <div className="sg-preview-dim" />
        <div
          className="sg-preview-popup sg-preview-popup--center sg-preview-popup--block"
          role="alertdialog"
          aria-label="Block page preview"
        >
          <div className="sg-preview-popup-body" style={{ textAlign: "center" }}>
            <p className="sg-preview-title">{title}</p>
            <p className="sg-preview-msg">{message}</p>
            {showContact ? (
              <p className="sg-preview-msg" style={{ marginBottom: 8 }}>
                <span style={{ textDecoration: "underline" }}>Contact us</span>
              </p>
            ) : null}
            <p
              className="sg-preview-msg"
              style={{ marginBottom: 0, fontSize: 11 }}
            >
              Reference: SG-XXXX
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
